$(document).ready(function () {
    if ($('.animated-banner-wrapper').length > 0) {
        $('.widget-zone-area').each(function() {
            var $widgetZoneArea = $(this);
            if ($widgetZoneArea.hasClass('no-visibility')) {
                $widgetZoneArea.hide();
                $widgetZoneArea.removeClass('no-visibility');
            }
        });

        $('.zone-link').on('click', function() {
            var $widgetZoneArea = $(this);
            var widgetZoneAreaId = $widgetZoneArea.attr("widget-zone-area-id");

            $('.main').fadeIn();

            $widgetZoneArea.addClass("active");
            $('.zone-link').not(this).removeClass("active");

            $('.widget-zone-area').hide();
            $('#' + widgetZoneAreaId).addClass("active");
            $('#' + widgetZoneAreaId).fadeIn();
        });

        $('.carousel').slick({
            dots: true,
            slidesToShow: 1,
            adaptiveHeight: true
        });

        $('#frame-5 .animated-banner__text__button, .slick-slide .animated-banner__text__button').on('click', function() {
            WizardScroll('.animated-banner-content-wrapper', 25);
        });

        $('.animated-banner__text__button').on('click', function() {
            var linkClass = $(this).attr('data-framelink');
            $('.animated-banner-wrapper__progressbar__link--' + linkClass).click();
        });
    }
});